import { useEffect } from "react";

const TawkToWidget = ({ shouldHideButton }: { shouldHideButton: boolean }) => {
  useEffect(() => {
    // Skip entirely if SSR or hidden
    if (typeof window === "undefined" || shouldHideButton) return;

    try {
      // Avoid duplicate insertion
      if (document.getElementById("tawk-to")) return;

      const scriptEl = document.createElement("script");
      scriptEl.id = "tawk-to";
      scriptEl.src = "https://embed.tawk.to/6882081a796ea319266f30a7/1j0tuva3b";
      scriptEl.async = true;
      scriptEl.charset = "UTF-8";
      scriptEl.crossOrigin = "anonymous";

      const firstScript = document.getElementsByTagName("script")[0];
      if (firstScript?.parentNode) {
        firstScript.parentNode.insertBefore(scriptEl, firstScript);
      } else {
        document.body.appendChild(scriptEl);
      }

      (window as any).Tawk_API = (window as any).Tawk_API || {};

      return () => {
        try {
          scriptEl.parentNode?.removeChild(scriptEl);
          delete (window as any).Tawk_API;
        } catch (cleanupErr) {
          console.warn("TawkToWidget cleanup error:", cleanupErr);
        }
      };
    } catch (err) {
      console.warn("Suppressed error in TawkToWidget:", err);
    }
  }, [shouldHideButton]);

  return null;
};

export default TawkToWidget;
